@if (!loading()) {
    @if (invoices().length > 0) {
        <p class="download-limit-notice">
            Je kunt maximaal {{ maxDownload }} bestanden per keer downloaden. {{ selectedItems().length }} van
            {{ getTotalAttachments() }} bestand{{ getTotalAttachments() > 1 ? 'en' : '' }}
            geselecteerd.
        </p>

        @if (isOverLimit()) {
            <p class="download-limit-warning">
                Je hebt meer dan {{ maxDownload }} bestanden geselecteerd. Breng je selectie terug tot maximaal
                {{ maxDownload }} bestanden om te kunnen downloaden.
            </p>
        }

        <div class="download-button-container">
            <button
                [disabled]="selectedItems().length === 0 || isOverLimit() || downloading()"
                (click)="downloadSelected()"
                mat-raised-button
                color="primary">
                @if (downloading()) {
                    <i class="fa fa-spinner fa-spin"></i> Downloaden...
                } @else {
                    Download geselecteerd ({{ selectedItems().length }}) bestand{{
                        selectedItems().length > 1 ? 'en' : ''
                    }}
                }
            </button>

            @if (getTotalAttachments() > maxDownload) {
                <button (click)="selectFirstBatch()" mat-raised-button>Selecteer eerste {{ maxDownload }}</button>

                <button [disabled]="!hasNextBatch()" (click)="selectNextBatch()" mat-raised-button>
                    Selecteer volgende {{ maxDownload }}
                </button>
            } @else {
                <button (click)="toggleSelectAll()" mat-raised-button>
                    {{ isAllSelected() ? 'Alles deselecteren' : 'Alles selecteren' }}
                </button>
            }
        </div>
    }

    <div class="invoices-container">
        @for (row of displayRows(); track row.attachment) {
            <div class="attachment-item">
                <mat-checkbox
                    [checked]="isSelected(row.attachment)"
                    (change)="toggleSelection(row.attachment, row.invoice)">
                </mat-checkbox>
                <div class="attachment-label">
                    <span class="attachment-number">{{ getAttachmentNumber(row.attachment) }}.</span>
                    <span class="attachment-filename">
                        <span class="filename-base">{{ splitFilename(row.invoice.filename).base }}</span
                        ><span class="filename-ext">{{ splitFilename(row.invoice.filename).ext }}</span>
                    </span>
                </div>
            </div>
        } @empty {
            <p>Geen facturen gevonden</p>
        }
    </div>
} @else {
    <p>Facturen worden geladen...</p>
}
